import { Component, OnChanges, SimpleChanges, OnInit, Output, EventEmitter, ViewChild, ViewChildren, QueryList, OnDestroy, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlarmsService } from '../../services/alarms.service';
import { MatTableModule } from '@angular/material/table';
import { Subject, Observable, of, Subscription } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { environment } from '/app/environments/environment';
import { MessageService } from '../../services/webservice/message.service';
import { Alarm, AlarmsResponse } from '../../models/alarm.model';
import { MatPaginatorModule, MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { User } from '/app/users/models/users.model';
import { HelpService } from '/app/services/help/help.service';
import { LastposicionMonitorComponent } from '/app/mapaRiesgo/components/lastposicionMonitor/lastposicionMonitor.component';
import { UsersService } from '/app/users/services/usuers.service';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabsModule, MatTabGroup } from '@angular/material/tabs';
import { LastposicionService } from '/app/mapaRiesgo/services/lastposicion.service';
import { MonitorsService } from '/app/monitors/services/monitors.service';
import { MapaRiesgoComponent } from '/app/mapaRiesgo/components/mapa-riesgo/mapa-riesgo.component';
import { LastposicionComponent } from '/app/mapaRiesgo/components/lastposicion/lastposicion.component';
import { Monitor } from '/app/monitors/models/monitor.model';

@Component({
  selector: 'app-alarms-table',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MapaRiesgoComponent,
    LastposicionComponent,
    LastposicionMonitorComponent
  ],
  templateUrl: './alarms-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./alarms-table.component.scss']
})
export class AlarmsTableComponent implements OnChanges, OnInit, OnDestroy, AfterViewInit {
  private readonly topic: string = `${environment.topic}`;
  private destroy$ = new Subject<void>();
  private alarmMap = new Map<string, Alarm>();

  monitorId = input<string>("");
  monitorName = input<string>("");
  isSitrackAdministrator = input(false);
  monitores = input<Monitor[]>([]);

  @Output() alarmSelected = new EventEmitter<Alarm>();
  @Output() alarmsChange = new EventEmitter<Alarm[]>();
  @Output() closeAlarmDetails = new EventEmitter<boolean>();
  @Output() rowClicked = new EventEmitter<Alarm>();
  @Output() closeUsersDetails = new EventEmitter<void>();
  @Output() closeMonitorDetails = new EventEmitter<void>();
  isAdministrator = input(false);

  alarms = signal<Alarm[]>([]);
  isLoading = signal(false);
  isLoadingTodayAlarms = signal(false);
  error = signal<string | null>(null);
  selectedAlarmId = signal<string | null>(null);
  lastPositions = signal<any[]>([]);
  isRiskEvaluation = signal(false);
  isView = signal('CLASSIC');
  alarmsByAssetId: { [key: string]: Alarm[] } = {};
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChildren(MapaRiesgoComponent) mapaComponents?: QueryList<MapaRiesgoComponent>;
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  paginatedAlarms: Alarm[] = [];

  totalElements = 0;
  pageSize = 15;
  pageIndex = 0;
  pageSizeOptions = [10, 15, 25, 50];
  selectedTabIndex: number = 0;

  fitrelDay = true;

  newAlarmIds = new Set<string>();
  attendenAlarmIds = new Set<string>();
  highlightedAlarmId: string | null = null;
  private selectionTimer: any = null;
  private alarmSound: HTMLAudioElement | null = null;
  isMuted = signal(false);
  private pendingMapRefresh = false;
  private pendingCenterRequest: { latitude: number; longitude: number; assetName?: string; assetId?: string; color?: string; alarmData?: any } | null = null;

  private monitorUpdatedSub?: Subscription;

  userControl = new FormControl<string | User>('');
  userControlAtendio = new FormControl<string | User>('');
  isMonitorMode = signal(true);
  isFiltreDate = signal(true);
  selectedUser = signal<User | null>(null);
  selectedUserAtendio = signal<User | null>(null);
  filteredUsers$: Observable<User[]> = of([]);
  private allUsers: User[] = [];
  private allUsers$ = new BehaviorSubject<User[]>([]);
  get displayedColumns(): string[] {
    const base = ['holder', 'deviceId', 'event', 'direccion', 'timestamp', 'timestamp2', 'status'];
    if (this.isRiskEvaluation()) {
      return ['holder', 'deviceId', 'event', 'riskEvaluation', 'direccion', 'timestamp', 'timestamp2', 'status'];
    }
    return base;
  }

  get displayedColumnsHistorico(): string[] {
    const base = ['holder', 'deviceId', 'event', 'direccion', 'timestamp', 'timestamp2', 'atendio', 'reviso', 'casifDate', 'comentario', 'status'];
    if (this.isRiskEvaluation()) {
      return ['holder', 'deviceId', 'event', 'riskEvaluation', 'direccion', 'timestamp', 'timestamp2', 'atendio', 'reviso', 'casifDate', 'comentario', 'status'];
    }
    return base;
  }
  dataSource = new MatTableDataSource<User>([]);

  totalUsers = 0;
  pageSizeUsuer = 100;

  // Variable para rastrear si hay filtros activos
  hasActiveFilters = signal(false);

  filters = {
    resolvedBy: '',
    reviewingBy: '',
    fechaDesde: null as Date | null,
    fechaHasta: null as Date | null,
    dateRangePreset: ''
  };

  constructor(
    private alarmsService: AlarmsService,
    private messageService: MessageService,
    private usersService: UsersService,
    private helpService: HelpService,
    private cdRef: ChangeDetectorRef,
    private lastposicionService: LastposicionService,
    private monitorsService: MonitorsService
  ) {
    this.alarmSound = new Audio('assets/beep-6-96243.mp3');
    this.alarmSound.volume = 0.90;
  }

  ngOnInit(): void {
    this.initializeUserFilter();

    // Suscribirse a actualizaciones de monitor para reflejar cambios de vista inmediatamente
    this.monitorUpdatedSub = this.monitorsService.monitorUpdated.subscribe((m: any) => {
      if (!m || !this.monitorId()) return;
      try {
        if (String(m.id) === String(this.monitorId())) {
          const newView = (m.view as string) || (m.showMap && !m.showTable ? 'MAP' : (m.showTable && !m.showMap ? 'CLASSIC' : (m.showTable && m.showMap ? 'TABS' : this.isView())));
          if (newView && newView !== this.isView()) {
            this.isView.set(newView);
            this.cdRef.markForCheck();
            if (this.tabGroup) {
              if (this.isView() === 'CLASSIC') this.tabGroup.selectedIndex = 0;
              if (this.isView() === 'MAP') this.tabGroup.selectedIndex = 1;
            }
          }
        }
      } catch (e) {
        // ignore
      }
    });

    if (!this.monitorId()) {
      this.loadAllAlarms();
    } else {
      // Si hay monitorId al inicializar, cargar alarmas del día
      this.loadAlarmsTodayByMonitor(this.monitorId());
    }
  }

  ngAfterViewInit(): void {
    this.updatePaginatedAlarms();
    this.mapaComponents?.changes
      .pipe(startWith(this.mapaComponents), takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.pendingMapRefresh || this.lastPositions().length > 0) {
          setTimeout(() => this.refreshMapMarkers(), 0);
        }
        // Process any pending center request now that mapa components are available
        if (this.pendingCenterRequest && this.mapaComponents && this.mapaComponents.length > 0) {
          const p = this.pendingCenterRequest;
          this.pendingCenterRequest = null;
          const mapa = this.mapaComponents.toArray()[0];
          if (mapa) {
            if (typeof mapa.requestCenter === 'function') {
              mapa.requestCenter(p.latitude, p.longitude, p.assetName || 'Vehículo', p.assetId, p.color, p.alarmData);
            } else {
              try {
                mapa.centerMapOnVehicle(p.latitude, p.longitude, p.assetName || 'Vehículo', p.assetId, p.color, p.alarmData);
              } catch (e) {
                // ignore
              }
            }
          }
        }
      });

    setTimeout(() => {
      this.loadLastPositions(this.monitorId() || undefined);
    }, 500);
  }

  onTabChange(event: any): void {
    this.selectedTabIndex = event.index;

    if (event.index === 0) {
      // Tab "Alarmas" — recargar la lista de alarmas
      // setTimeout permite que mat-tab termine de renderizar el contenido del tab
      setTimeout(() => {
        this.pageIndex = 0;
        if (this.monitorId()) {
          if (this.isMonitorMode()) {
            this.loadAlarmsByMonitor(this.monitorId());
          } else {
            this.loadAlarmsByMonitorHistory(this.monitorId());
          }
        }
      });
    }

    if (event.index === 1 || event.index === 2) {
      // Tab del mapa (tanto Mapa de Alarmas como Mapa de Riesgo)
      // Emitir evento para cerrar los detalles de alarma en el componente padre
      this.closeAlarmDetails.emit(false);
      this.closeUsersDetails.emit();
      this.closeMonitorDetails.emit();

      setTimeout(() => {
        if (this.mapaComponents) {
          this.mapaComponents.forEach((mapaComponent, index) => {
            mapaComponent.invalidateSize?.();
          });
        }
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      }, 300);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.selectionTimer) {
      clearTimeout(this.selectionTimer);
    }

    if (this.monitorUpdatedSub) {
      this.monitorUpdatedSub.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.monitores().length > 0) {
      this.getPopetisMonitor();
    }

    if (this.monitorId()) {
      this.destroy$.next();
      this.newAlarmIds.clear();
      this.highlightedAlarmId = null;
      this.pageIndex = 0;

      this.loadAlarmsByMonitor(this.monitorId());
      this.loadLastPositions(this.monitorId());

    } else {
      this.loadAllAlarms();
    }
  }

  private initializeUserFilter(): void {
    this.loadUsers();

    this.filteredUsers$ = combineLatest([
      this.userControl.valueChanges.pipe(startWith('')),
      this.allUsers$
    ]).pipe(
      map(([value, users]) => {
        const searchTerm = this.getDisplayValue(value);
        if (!searchTerm) return users;
        const term = searchTerm.toLowerCase();
        return users.filter(user =>
          user.name?.toLowerCase().includes(term) ||
          user.familyName?.toLowerCase().includes(term) ||
          user.email?.toLowerCase().includes(term)
        );
      }),
      takeUntil(this.destroy$)
    );
  }

  getDisplayValue(value: string | User | null): string {
    if (typeof value === 'string') {
      return value;
    }
    if (value && typeof value === 'object' && 'name' in value) {
      return `${value.name} ${value.familyName}`;
    }
    return '';
  }

  loadUsers(callback?: () => void): void {
    this.usersService.getUsers(0, this.pageSizeUsuer).subscribe({
      next: (resp: any) => {
        // Filtrar usuarios activos y almacenar en allUsers
        this.allUsers = resp.content.filter((user: User) => user.active);

        // Actualizar el BehaviorSubject con los usuarios
        this.allUsers$.next(this.allUsers);

        if (callback) callback();
      },
      error: (error) => {
        if (error?.status == 403) {
        } else {
        }
      }
    });
  }

  private filterUsers(searchTerm: string): User[] {
    if (!searchTerm) {
      return this.allUsers;
    }

    const term = searchTerm.toLowerCase();
    return this.allUsers.filter(user =>
      user.name?.toLowerCase().includes(term) ||
      user.familyName?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term)
    );
  }

  onUserSelected(user: User): void {
    if (!user || !user.cognitoSub) {
      return;
    }

    this.selectedUser.set(user);
    this.userControl.setValue(`${user.name} ${user.familyName}`, { emitEvent: false });

    // Actualizar el filtro correspondiente
    this.filters.resolvedBy = user.cognitoSub;
  }



  onUserSelectedAtendio(user: User): void {
    if (!user || !user.cognitoSub) {
      return;
    }

    this.selectedUserAtendio.set(user);
    this.userControlAtendio.setValue(`${user.name} ${user.familyName}`, { emitEvent: false });

    // Actualizar el filtro correspondiente
    this.filters.reviewingBy = user.cognitoSub;
  }



  displayUserFn(user: User): string {
    return user ? `${user.name} ${user.familyName}` : '';
  }

  private sortAlarmsByGpsDate(alarms: Alarm[]): Alarm[] {
    return [...alarms].sort((a, b) => {
      const dateA = a.gpsReport?.inputDate ? new Date(a.gpsReport.inputDate).getTime() : 0;
      const dateB = b.gpsReport?.inputDate ? new Date(b.gpsReport.inputDate).getTime() : 0;
      return dateB - dateA;
    });
  }

  private sortAlarmsByGpsDateAndColor(alarms: Alarm[]): Alarm[] {
    const colorPriority: { [key: string]: number } = {
      '#ff0000': 1,
      '#ff8000': 2,
      '#ffff00': 3,
      '#0080ff': 4,
    };

    return [...alarms].sort((a, b) => {
      const priorityA = a.color ? (colorPriority[a.color.toLowerCase()] || 999) : 999;
      const priorityB = b.color ? (colorPriority[b.color.toLowerCase()] || 999) : 999;

      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }

      const dateA = a.gpsReport?.reportDate ? new Date(a.gpsReport.reportDate).getTime() : 0;
      const dateB = b.gpsReport?.reportDate ? new Date(b.gpsReport.reportDate).getTime() : 0;

      return dateB - dateA;
    });
  }

  private updatePaginatedAlarms(): void {    
    if (this.paginator) {
      this.paginator.length = this.totalElements;
    }

    // Si hay filtros activos o no estamos en modo monitor, 
    // los datos ya vienen paginados del servidor
    if (this.hasActiveFilters() || !this.isMonitorMode()) {
      this.paginatedAlarms = this.alarms();
    } else {
      // Para modo monitor (tiempo real), aplicar paginación localmente
      const start = this.pageIndex * this.pageSize;
      const end = start + this.pageSize;
      this.paginatedAlarms = this.alarms();
    }

    this.alarmsChange.emit([...this.alarms()]);
  }

  private adjustPageIndexAfterDeletion(): void {
    const totalPages = Math.ceil(this.totalElements / this.pageSize);
    const originalPageIndex = this.pageIndex;

    if (this.totalElements === 0) {
      this.pageIndex = 0;
    } else if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1;
    }

    const currentPageHasElements = this.alarms().length > 0;
    const pageIndexChanged = originalPageIndex !== this.pageIndex;

    if (!currentPageHasElements || pageIndexChanged) {
      if (this.monitorId()) {
        this.loadAlarmsByMonitor(this.monitorId());
      } else if (this.totalElements > 0) {
        this.loadAllAlarms();
      }
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    const maxPageIndex = Math.ceil(this.totalElements / this.pageSize) - 1;
    if (this.pageIndex > maxPageIndex && maxPageIndex >= 0) {
      this.pageIndex = maxPageIndex;
    }

    // Si estamos en modo histórico
    if (!this.isMonitorMode() && this.monitorId()) {
      if (this.hasActiveFilters()) {
        // Re-aplicar los filtros respetando pageIndex y pageSize
        this.applyFiltersWithPagination();
      } else {

        // Cargar histórico estándar (rango por defecto)
        this.loadAlarmsByMonitorHistoryPaginated(this.monitorId());
      }
    } else if (this.monitorId()) {
      // Modo monitor - cargar página siguiente SIN CAMBIAR isMonitorMode
      this.loadAlarmsByMonitorPaginated(this.monitorId());
    } else {
      this.loadAllAlarms();
    }
  }

  loadAlarmsByMonitor(monitorId: string): void {
    // this.getPopetisMonitor();
    this.isRiskEvaluation.set(false);

    if (this.monitorId() && this.monitores().length > 0) {
      const monitorEncontrado = this.monitores().find(monitor => monitor.id === this.monitorId());
      if (monitorEncontrado) {
        if (monitorEncontrado.riskEvaluation === true) {
          this.isRiskEvaluation.set(monitorEncontrado.riskEvaluation);
        }
        this.isView.set(monitorEncontrado.view || 'CLASSIC');

      }
    }

    this.isLoading.set(true);
    this.error.set(null);
    this.isMonitorMode.set(true);
    this.pageIndex = 0;
    const maxPageIndex = Math.ceil(this.totalElements / this.pageSize) - 1;
    if (this.pageIndex > maxPageIndex && maxPageIndex >= 0) {
      this.pageIndex = maxPageIndex;
    }

    this.alarmsService.getAlarms(monitorId, this.pageIndex, this.pageSize).subscribe({
      next: (response: AlarmsResponse) => {
        this.alarms.set(
          this.fitrelDay
            ? this.sortAlarmsByGpsDate(response.content)
            : this.sortAlarmsByGpsDateAndColor(response.content)
        );

        this.totalElements = response.totalElements;
        // Sincronizar estado de infinite scroll
        this.mapScrollAlarms.set([...this.alarms()]);
        this.mapScrollPageIndex = 0;
        this.updatePaginatedAlarms();
        this.isLoading.set(false);
        this.cdRef.detectChanges();
        this.subscribeToRealTimeUpdates(monitorId);
      },
      error: (err: any) => this.handleError('Error al cargar las alarmas: ', err)
    });

  }


  loadAlarmsTodayByMonitor(monitorId: string): void {
    this.isRiskEvaluation.set(false);
    this.isLoadingTodayAlarms.set(true);

    this.alarmsService.getAllTodayAlarms(monitorId).subscribe({
      next: (response: Alarm[]) => {
        // Crear un nuevo arreglo/objeto con assetId como clave y arreglo de alarmas como valor
        const alarmsByAssetId: { [key: string]: Alarm[] } = {};
        response.forEach(alarm => {
          const assetId = alarm.gpsReport?.assetId;
          if (assetId) {
            if (!alarmsByAssetId[assetId]) {
              alarmsByAssetId[assetId] = [];
            }
            alarmsByAssetId[assetId].push(alarm);
          }
        });

        // Ordenar cada arreglo por gpsReport.reportDate (más reciente primero)
        Object.keys(alarmsByAssetId).forEach(key => {
          alarmsByAssetId[key].sort((a, b) => {
            const dateA = new Date(a.gpsReport?.reportDate || 0).getTime();
            const dateB = new Date(b.gpsReport?.reportDate || 0).getTime();
            return dateB - dateA; // Más reciente primero
          });
        });

        // Asignar al componente
        this.alarmsByAssetId = alarmsByAssetId;

        this.isLoadingTodayAlarms.set(false);
      },
      error: (err: any) => {
        this.handleError('Error al cargar las alarmas: ', err);
        this.isLoadingTodayAlarms.set(false);
      }
    });


  }


  private loadAlarmsByMonitorPaginated(monitorId: string): void {
    this.isLoading.set(true);
    this.error.set(null);
    // NO cambiar isMonitorMode - mantener estado actual

    this.alarmsService.getAlarms(monitorId, this.pageIndex, this.pageSize).subscribe({
      next: (response: AlarmsResponse) => {
        this.alarms.set(
          this.fitrelDay
            ? this.sortAlarmsByGpsDate(response.content)
            : this.sortAlarmsByGpsDateAndColor(response.content)
        );

        this.totalElements = response.totalElements;
        this.updatePaginatedAlarms();
        this.isLoading.set(false);
      },
      error: (err: any) => this.handleError('Error al cargar las alarmas: ', err)
    });
  }

  loadAlarmsByMonitorHistory(monitorId: string): void {
    this.loadUsers();
    this.isLoading.set(true);
    this.error.set(null);
    this.isMonitorMode.set(false);
    this.pageIndex = 0;

    const maxPageIndex = Math.ceil(this.totalElements / this.pageSize) - 1;
    if (this.pageIndex > maxPageIndex && maxPageIndex >= 0) {
      this.pageIndex = maxPageIndex;
    }

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    this.alarmsService.getAlarms(
      monitorId,
      this.pageIndex,
      this.pageSize,
      {
        status: '*',
        startDate: todayStart.toISOString(),
        endDate: todayEnd.toISOString(),
      }
    ).subscribe({
      next: (response: AlarmsResponse) => {
        this.alarms.set(
          this.fitrelDay
            ? this.sortAlarmsByGpsDate(response.content)
            : this.sortAlarmsByGpsDateAndColor(response.content)
        );

        this.totalElements = response.totalElements;
        this.updatePaginatedAlarms();
        this.isLoading.set(false);
        this.cdRef.detectChanges();
        this.subscribeToRealTimeUpdates(monitorId);
      },
      error: (err: any) => this.handleError('Error al cargar las alarmas: ', err)
    });
  }

  private loadAlarmsByMonitorHistoryPaginated(monitorId: string): void {
    this.isLoading.set(true);
    this.error.set(null);
    // NO cambiar isMonitorMode - mantener estado actual (histórico)

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    this.alarmsService.getAlarms(
      monitorId,
      this.pageIndex,
      this.pageSize,
      {
        status: '*',
        startDate: todayStart.toISOString(),
        endDate: todayEnd.toISOString(),
      }
    ).subscribe({
      next: (response: AlarmsResponse) => {
        this.alarms.set(
          this.fitrelDay
            ? this.sortAlarmsByGpsDate(response.content)
            : this.sortAlarmsByGpsDateAndColor(response.content)
        );

        this.totalElements = response.totalElements;
        this.updatePaginatedAlarms();
        this.isLoading.set(false);
      },
      error: (err: any) => this.handleError('Error al cargar las alarmas: ', err)
    });
  }

  loadAllAlarms(): void {
    this.isLoading.set(true);
    this.error.set(null);

    this.isLoading.set(false);
    this.updatePaginatedAlarms();
  }

  private subscribeToGlobalUpdates(): void {
    this.messageService
      .subscribeToTopic(`${this.topic}/global`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (message) => this.handleWebSocketMessage(message),
        error: (err) => { }
      });
  }

  private subscribeToRealTimeUpdates(monitorId: string): void {
    this.messageService
      .subscribeToTopic(`${this.topic}/${monitorId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (message) => this.handleWebSocketMessage(message),
        error: (err) => { }
      });
  }

  private handleWebSocketMessage(message: any): void {

    try {
      const webMessage = typeof message.body === 'string'
        ? JSON.parse(message.body)
        : message.body;

      // Si el mensaje trae un gpsReport con assetId, buscar en las últimas posiciones
      // y combinar/ reemplazar los campos del gpsReport con los datos más recientes.

      switch (webMessage.operation) {
        case 'UPDATE':
          this.handleUpdateOperation(webMessage.payload);
          break;
        case 'CREATE':
          this.upsertLastPositionFromAlarm(webMessage.payload);
          this.handleCreateOperation(webMessage.payload);
          try {
            const assetId = webMessage?.payload?.gpsReport?.assetId || webMessage?.payload?.assetId;
            if (assetId && Array.isArray(this.lastPositions()) && this.lastPositions().length > 0) {
              const matched = this.lastPositions().find((lp: any) => lp && (lp.assetId === assetId || String(lp.assetId) === String(assetId)));
              if (matched) {
                webMessage.payload.gpsReport = { ...webMessage.payload.gpsReport, ...matched };
              }
            }
          } catch (e) {
            // No bloquear el procesamiento del mensaje si falla la combinación
          }



          break;
        case 'RECOGNIZE':
          this.handleCreateAttended(webMessage.payload);
          break;
        case 'BULK_RESOLVE':
          this.handleCreateBulkResolve(webMessage.payload);
          break;
        default:
          break;
      }
    } catch (error) {
    }
  }

  private handleUpdateOperation(alarmData: Alarm): void {
    
    const index = this.alarms().findIndex(a => a.id === alarmData.id);
    if (index !== -1) {
      this.alarms.update(items => {
        items.splice(index, 1);
        const sorted = this.fitrelDay
          ? this.sortAlarmsByGpsDate([...items])
          : this.sortAlarmsByGpsDateAndColor([...items]);
        return sorted;
      });

      this.updatePaginatedAlarms();
    }

    // Sincronizar panel lateral del mapa
    this.removeFromMapScrollAlarms(alarmData.id);
  }

  private handleCreateOperation(alarmData: Alarm): void {
    // handleCreateOperation invoked (log removed)


    if (this.pageIndex === 0) {
      const existingIndex = this.alarms().findIndex(a => a.id === alarmData.id);
      if (existingIndex === -1) {
        this.alarms.update(items => [alarmData, ...items.slice(0, this.pageSize - 1)]);
        this.alarms.set(
          this.fitrelDay
            ? this.sortAlarmsByGpsDate(this.alarms())
            : this.sortAlarmsByGpsDateAndColor(this.alarms())
        );

        this.updatePaginatedAlarms();
        this.totalElements++;
        this.newAlarmIds.add(alarmData.id);

        if (this.alarmSound && !this.isMuted()) {
          this.alarmSound.play().catch(e => { });
        }
      } else {
        this.handleUpdateOperation(alarmData);
      }
    } else {
      this.totalElements++;
    }

    // Sincronizar panel lateral del mapa: agregar al inicio
    this.addToMapScrollAlarms(alarmData);
  }

  private handleCreateAttended(alarmData: Alarm): void {
















































    this.attendenAlarmIds.clear();
    const index = this.alarms().findIndex(a => a.id === alarmData.id);

    if (index !== -1) {
      this.alarms.update(items => {
        const updated = [...items];
        updated[index] = { ...updated[index], ...alarmData };
        return updated;
      });
      this.attendenAlarmIds.add(alarmData.id);

      if (this.newAlarmIds.has(alarmData.id)) {
        this.newAlarmIds.delete(alarmData.id);
      }

      this.highlightedAlarmId = null;
    } else {
      this.alarms.update(items => [...items, alarmData]);
      this.attendenAlarmIds.add(alarmData.id);
      this.totalElements++;
    }

    this.alarms.set(
      this.fitrelDay
        ? this.sortAlarmsByGpsDate([...this.alarms()])
        : this.sortAlarmsByGpsDateAndColor([...this.alarms()])
    );

    this.updatePaginatedAlarms();
    this.cdRef.detectChanges();
    this.alarmMap.set(alarmData.id, alarmData);

    // Sincronizar panel lateral del mapa
    this.updateInMapScrollAlarms(alarmData);
  }

  private handleCreateBulkResolve(payload: any): void {
    let alarmIdsToRemove: string[] = [];

    if (Array.isArray(payload)) {
      if (payload.length > 0 && typeof payload[0] === 'string') {
        // Payload es array de IDs (strings)
        alarmIdsToRemove = payload as string[];
      } else if (payload.length > 0 && typeof payload[0] === 'object' && payload[0].id) {
        // Payload es array de Alarm objects
        alarmIdsToRemove = payload.map((alarm: Alarm) => alarm.id);
      } else {
        return;
      }
    } else if (typeof payload === 'object' && payload.resolvedAlarms && Array.isArray(payload.resolvedAlarms)) {
      // Payload es objeto con propiedad resolvedAlarms
      alarmIdsToRemove = payload.resolvedAlarms.map((alarm: Alarm) => alarm.id);
    } else {
      return;
    }

    let removedCount = 0;
    alarmIdsToRemove.forEach((alarmId: string) => {
      const index = this.alarms().findIndex(a => a.id === alarmId);
      if (index !== -1) {
        this.alarms.update(items => {
          items.splice(index, 1);
          return [...items];
        });
        removedCount++;

        // Remover de los sets si estaban ahí
        if (this.newAlarmIds.has(alarmId)) {
          this.newAlarmIds.delete(alarmId);
        }
        if (this.attendenAlarmIds.has(alarmId)) {
          this.attendenAlarmIds.delete(alarmId);
        }
      }
    });

    // Actualizar el contador total
    this.totalElements -= removedCount;

    // Reordenar las alarmas restantes
    this.alarms.set(
      this.fitrelDay
        ? this.sortAlarmsByGpsDate([...this.alarms()])
        : this.sortAlarmsByGpsDateAndColor([...this.alarms()])
    );

    this.updatePaginatedAlarms();
    this.cdRef.detectChanges();

    // Recargar la tabla de alarmas para asegurar consistencia con el servidor
    if (this.monitorId()) {
      if (this.isMonitorMode()) {
        this.loadAlarmsByMonitorPaginated(this.monitorId());
      } else {
        this.loadAlarmsByMonitorHistoryPaginated(this.monitorId());
      }
    }

    // Sincronizar panel lateral del mapa: eliminar alarmas resueltas
    this.bulkRemoveFromMapScrollAlarms(alarmIdsToRemove);
  }

  onRowClick(payload: any): void {
    // payload puede ser: 1) un Alarm directamente (click en tabla),
    // o 2) { alarm, source } cuando lo invoca app-lastposicion-monitor
    const alarm: Alarm = payload && payload.alarm ? payload.alarm : payload as Alarm;
    const source: string | undefined = payload && payload.source ? payload.source : undefined;

    this.selectedAlarmId.set(alarm.id);
    this.alarmsService.doAttended(alarm.id, alarm.monitorId).subscribe({
      next: (data: Alarm) => {
        // Si la acción viene desde el listado (tabla), emitir para abrir detalles.
        if (source !== 'lastposicion') {
          this.rowClicked.emit(data);
        }
        // Si viene desde lastposicion, no emitimos rowClicked (no abrir detalles).
      },
      error: (err: any) => this.handleError('Error al cargar la alarma: ', err)
    });
  }

  private handleError(message: string, err: any): void {
    this.error.set(message + (err.message || 'Error desconocido'));
    this.isLoading.set(false);
  }

  getRowClass(alarm: Alarm): string {
    let classes = '';
    if (this.selectedAlarmId() === alarm.id) classes += 'selected-row ';
    if (this.newAlarmIds.has(alarm.id)) classes += 'new-alarm ';
    if (this.highlightedAlarmId === alarm.id) classes += 'highlighted-alarm ';
    if (alarm.color) classes += 'custom-color ';
    return classes.trim();
  }

  getRowStyle(alarm: Alarm): any {
    if (alarm.color) {
      return {
        'background-color': alarm.color + ' !important',
        'color': this.getContrastColor(alarm.color) + ' !important'
      };
    }
    return {};
  }

  getContrastColor(hexColor: string): string {
    const color = hexColor.replace('#', '');
    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#FFFFFF';
  }

  getStatusText(status: any): string {
    const normalizedStatus = String(status).toUpperCase().trim();
    const statusMap: { [key: string]: string } = {
      'NEW': 'Nuevo',
      'IN_PROGRESS': 'En Progreso',
      'RESOLVED': 'Resuelto',
      'CLOSED': 'Cerrado'
    };
    return statusMap[normalizedStatus] || `Alarma sin Clasificar`;
  }

  toggleMute(): void {
    this.isMuted.update(v => !v);
    if (this.alarmSound) {
      if (this.isMuted()) {
        try {
          this.alarmSound.pause();
          this.alarmSound.currentTime = 0;
        } catch (e) {
        }
      } else {
        this.alarmSound.volume = 0.90;
      }
    }
  }

  toggleMonitorMode() {
    this.isMonitorMode.update(v => !v);

    if (!this.monitorId()) {
      return;
    }
    if (this.isMonitorMode()) {
      this.loadAlarmsByMonitor(this.monitorId());
    } else {
      this.loadAlarmsByMonitorHistory(this.monitorId());
    }
  }

  exportCSV() {
    if (!this.monitorId()) {
      return;
    }
    const filterPayload = this.buildFilterPayload();

    const page = 0;
    const size = this.totalElements > 0 ? this.totalElements : 50000;

    this.alarmsService.exportAlarmsCsv(
      this.monitorId(),
      filterPayload
    ).subscribe({
      next: (blob: Blob) => {
        if (!blob) return;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `alarmas_${new Date().toISOString()}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
      }
    });
  }

  resetFilters() {
    const today = new Date();

    this.filters = {
      resolvedBy: '',
      reviewingBy: '',
      fechaDesde: today,
      fechaHasta: today,
      dateRangePreset: ''
    };

    this.selectedUser.set(null);
    this.userControl.setValue('');
    this.hasActiveFilters.set(false);

    this.pageIndex = 0;

    this.isFiltreDate.set(true);
    if (this.isMonitorMode()) {
      this.loadAlarmsByMonitor(this.monitorId()!);
    } else {
      this.loadAlarmsByMonitorHistory(this.monitorId()!);
    }
  }


  applyFilters() {
    if (!this.monitorId()) {
      return;
    }

    this.pageIndex = 0;
    this.hasActiveFilters.set(true);
    this.applyFiltersWithPagination();
  }

  private applyFiltersWithPagination() {
    if (!this.monitorId()) {
      return;
    }

    this.isLoading.set(true);

    const filterPayload: any = {
      status: '*'
    };

    if (this.filters.resolvedBy.trim() !== '') {
      filterPayload.resolvedBy = this.filters.resolvedBy.trim();
    }
    if (this.filters.reviewingBy.trim() !== '') {
      filterPayload.reviewingBy = this.filters.reviewingBy.trim();
    }
    if (this.filters.fechaDesde) {
      filterPayload.startDate = new Date(this.filters.fechaDesde).toISOString();
    }
    if (this.filters.fechaHasta) {
      const end = new Date(this.filters.fechaHasta);
      end.setHours(23, 59, 59, 999);
      filterPayload.endDate = end.toISOString();
    }
    if (this.filters.dateRangePreset) {
      filterPayload.dateRangePreset = this.filters.dateRangePreset;
    }



    this.alarmsService.getAlarms(
      this.monitorId(),
      this.pageIndex,
      this.pageSize,
      filterPayload
    ).subscribe({
      next: (response) => {

        // applyFiltersWithPagination response (log removed)
        this.alarms.set(
          this.fitrelDay
            ? this.sortAlarmsByGpsDate(response.content)
            : this.sortAlarmsByGpsDateAndColor(response.content)
        );

        this.totalElements = response.totalElements;
        this.updatePaginatedAlarms();
        this.isLoading.set(false);
      },
      error: (err) => this.handleError('Error al aplicar filtros: ', err)
    });
  }

  private buildFilterPayload(): any {
    const filterPayload: any = { status: '*' };

    if (this.filters.resolvedBy.trim() !== '') {
      filterPayload.resolvedBy = this.filters.resolvedBy.trim();
    }
    if (this.filters.reviewingBy.trim() !== '') {
      filterPayload.reviewingBy = this.filters.reviewingBy.trim();
    }
    if (this.filters.fechaDesde) {
      filterPayload.startDate = new Date(this.filters.fechaDesde).toISOString();
    }
    if (this.filters.fechaHasta) {
      const end = new Date(this.filters.fechaHasta);
      end.setHours(23, 59, 59, 999);
      filterPayload.endDate = end.toISOString();
    }

    if (this.filters.dateRangePreset) {
      filterPayload.dateRangePreset = this.filters.dateRangePreset;
    }

    return filterPayload;
  }

  onDateRangePresetChange(value: string): void {
    if (value === "") {
      this.isFiltreDate.set(true);
    } else {
      this.isFiltreDate.set(false);
      this.filters.fechaDesde = null;
      this.filters.fechaHasta = null;
    }
  }

  showAlarmsHelp(): void {
    const steps = this.isMonitorMode()
      ? this.helpService.getAlarmsTableHelpSteps()
      : this.helpService.getHistoricoFiltersHelpSteps();

    this.helpService.startTour(steps, 'Ayuda - Tabla de Alarmas');
  }


  private loadLastPositions(monitorId?: string): void {
    // loadLastPositions called (log removed)

    const handleResponse = (data: any) => {
      // loadLastPositions response (log removed)
      this.lastPositions.set(this.normalizeLastPositions(data));
    
      this.cdRef.detectChanges();
      this.refreshMapMarkers();
    };

      // Normalized lastPositions (log removed)

    const handleError = (err: any) => {
      console.error('loadLastPositions error:', err);
      this.lastPositions.set([]);
      this.refreshMapMarkers();
    };

    if (monitorId) {
      this.lastposicionService.getLastPosition(monitorId).subscribe({ next: handleResponse, error: handleError });
    }
    // else if (!this.lastPositions.length) {
    //   // Sin monitor seleccionado: solicitar posiciones por preset (comportamiento original)
    //   this.lastposicionService.getLastPosition().subscribe({ next: handleResponse, error: handleError });
    // }
  }


  onVehicleSelected(position: { latitude: number; longitude: number; assetName: string; assetId: string; color?: string; alarmData?: any }): void {
    // console statements removed
    // Queue the request; will be used as fallback if no component is found
    this.pendingCenterRequest = {
      latitude: position.latitude,
      longitude: position.longitude,
      assetName: position.assetName,
      assetId: position.assetId,
      color: position.color,
      alarmData: position.alarmData
    };

    if (!this.mapaComponents || this.mapaComponents.length === 0) {
      // pendingCenterRequest already set — will be processed when components become available
      return;
    }

    // Determine which mapa component index to use.
    // Tab layout depends on isView:
    //   MAP   → only "Mapa de Alarmas" rendered → tabs: [0=Mapa]             → mapaIndex=0
    //   TABS  → "Alarmas"(0) + "Mapa"(1) + optional "Riesgo"(2)              → mapaIndex depends on selectedTabIndex
    //   CLASSIC → no mapa tab rendered                                        → mapaIndex=0 (fallback, won't show)
    let mapaIndex = 0;
    if (this.isView() === 'TABS') {
      if (this.selectedTabIndex === 2 && this.mapaComponents.length > 1) {
        mapaIndex = 1; // Mapa de Riesgo
      } else {
        mapaIndex = 0; // Mapa de Alarmas
      }
    } else {
      // MAP mode (or any other): first (and only) mapa component
      mapaIndex = 0;
    }

    mapaIndex = Math.min(mapaIndex, this.mapaComponents.length - 1);
    const mapaComponent = this.mapaComponents.toArray()[mapaIndex];
    if (!mapaComponent) {
      return;
    }

    if (typeof mapaComponent.requestCenter === 'function') {
      mapaComponent.requestCenter(position.latitude, position.longitude, position.assetName, position.assetId, position.color, position.alarmData);
      this.pendingCenterRequest = null;
    } else {
      try {
        mapaComponent.centerMapOnVehicle(position.latitude, position.longitude, position.assetName, position.assetId, position.color, position.alarmData);
        this.pendingCenterRequest = null;
      } catch (e) {
        // pendingCenterRequest kept so it retries when components change
      }
    }
  }

  onLastPositionsUpdated(updatedPositions: any[]): void {
    // Actualizar lastPositions para que se refleje en el mapa
    this.lastPositions.set(this.normalizeLastPositions(updatedPositions));
    this.refreshMapMarkers();
  }

  private normalizeLastPositions(data: any): any[] {   

      // normalizeLastPositions called (log removed)

  let positions: any[] = [];

  if (data && Array.isArray(data.content)) {
    positions = data.content;
  } else if (data && Array.isArray(data.items)) {
    positions = data.items;
  } else if (Array.isArray(data)) {
    positions = data;
  } else if (data) {
    positions = [data];
  }

  return positions
    .map((position: any) => {
      const gps = position?.gpsReport || {};

      const normalizedPosition = {
        // ...gps,
        // ...position,
        assetId: position?.assetId ?? gps?.assetId ?? position?.deviceId,
        assetName: position?.assetName ?? gps?.assetName,
        color: position?.color ?? gps?.color ?? '#0f172a',
        eventName: position?.eventName ?? gps?.eventName,
        location: position?.location ?? gps?.location,
        latitude: position?.latitude ?? position?.lat ?? gps?.latitude ?? gps?.lat,
        longitude: position?.longitude ?? position?.lng ?? gps?.longitude ?? gps?.lng,
        reportDate: position?.reportDate ?? gps?.reportDate,
        inputDate: position?.inputDate ?? gps?.inputDate,
        riskEvaluation: position?.riskEvaluation ?? gps?.riskEvaluation,
        riskLabel: position?.riskLabel ?? gps?.riskLabel,
        heading: position?.heading ?? gps?.heading,
        zoneName: position?.zoneName ?? gps?.zoneName,
        speed: position?.speed ?? gps?.speed,
      };

      // debug logs removed

      return normalizedPosition;
    })
    .filter((position: any) => {
      const lat = position?.latitude;
      const lng = position?.longitude;

      const isValid =
        lat !== undefined &&
        lat !== null &&
        lng !== undefined &&
        lng !== null;

      if (!isValid) {
        console.warn('Posición descartada por no tener coordenadas:', position);
      }

      return isValid;
    });
  }

  private upsertLastPositionFromAlarm(alarmPayload: any): void {

    // upsertLastPositionFromAlarm invoked (log removed)

    let gps = alarmPayload?.gpsReport;
    if (!gps) {
      return;
    }

    // Añadir/forzar propiedades en el gps tomando valores de la alarma si existen
    gps = {
      ...gps,
      color: alarmPayload?.color ?? gps?.color,
      // algunos payloads colocan riskEvaluation/riskLabel en el objeto superior de la alarma
      riskEvaluation: alarmPayload?.riskEvaluation ?? gps?.riskEvaluation,
      riskLabel: alarmPayload?.riskLabel ?? gps?.riskLabel,
    };
    const [normalizedGps] = this.normalizeLastPositions([gps]);
    if (!normalizedGps) {
      return;
    }

    const assetId = normalizedGps.assetId;
    if (!assetId) {
      return;
    }

    const index = this.lastPositions().findIndex((p: any) => String(p?.assetId) === String(assetId));
    if (index >= 0) {
      this.lastPositions.update(items => {
        const updated = [...items];
        updated[index] = { ...updated[index], ...normalizedGps };
        return updated;
      });
    } else {
      this.lastPositions.update(items => [normalizedGps, ...items]);
    }

    this.refreshMapMarkers();
  }

  private refreshMapMarkers(): void {
    this.cdRef.detectChanges();

    if (!this.mapaComponents || this.mapaComponents.length === 0) {
      this.pendingMapRefresh = true;
      return;
    }

    this.pendingMapRefresh = false;
    this.mapaComponents.forEach((mapaComponent) => {
      try {
        (mapaComponent as any).lastPositions = [...this.lastPositions()];
        (mapaComponent as any).refreshMarkers?.();
      } catch (e) {
      }
    });
  }

  switchToAlarmsTab(): void {
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = 0; // Switch to Alarmas tab
    }
  }


  getPopetisMonitor() {

    if (this.monitorId() && this.monitores().length > 0) {
      const monitorEncontrado = this.monitores().find(monitor => monitor.id === this.monitorId());
      if (monitorEncontrado) {
        if (monitorEncontrado.riskEvaluation === true) {
          this.isRiskEvaluation.set(monitorEncontrado.riskEvaluation);
        }
      }
    }
  }

  // ---- Infinite scroll para el panel lateral del mapa ----

  private mapScrollPageIndex = 0;
  mapScrollAlarms = signal<Alarm[]>([]);
  isLoadingMapAlarms = signal(false);
  filteredAssetIds: string[] | null = null;

  onFilteredAssetIdsChange(assetIds: string[] | null): void {
    this.filteredAssetIds = assetIds;
  }

  onLoadMoreAlarms(): void {
    if (!this.monitorId() || this.isLoadingMapAlarms()) return;

    const hasMore = this.mapScrollAlarms().length < this.totalElements;
    if (!hasMore) return;

    this.isLoadingMapAlarms.set(true);
    this.mapScrollPageIndex++;

    this.alarmsService.getAlarms(this.monitorId(), this.mapScrollPageIndex, this.pageSize).subscribe({
      next: (response: AlarmsResponse) => {
        const newAlarms = response.content || [];
        this.mapScrollAlarms.set(
          this.fitrelDay
            ? this.sortAlarmsByGpsDate([...this.mapScrollAlarms(), ...newAlarms])
            : this.sortAlarmsByGpsDateAndColor([...this.mapScrollAlarms(), ...newAlarms])
        );
        this.totalElements = response.totalElements;
        this.isLoadingMapAlarms.set(false);
      },
      error: () => {
        this.isLoadingMapAlarms.set(false);
      }
    });
  }

  // ---- Helpers para sincronizar mapScrollAlarms con WebSocket ----

  /** Agregar una alarma nueva al panel del mapa */
  private addToMapScrollAlarms(alarm: Alarm): void {
    const existingIndex = this.mapScrollAlarms().findIndex(a => a.id === alarm.id);
    if (existingIndex === -1) {
      this.mapScrollAlarms.set(
        this.fitrelDay
          ? this.sortAlarmsByGpsDate([alarm, ...this.mapScrollAlarms()])
          : this.sortAlarmsByGpsDateAndColor([alarm, ...this.mapScrollAlarms()])
      );
    } else {
      this.updateInMapScrollAlarms(alarm);
    }
  }

  /** Actualizar una alarma existente en el panel del mapa */
  private updateInMapScrollAlarms(alarm: Alarm): void {
    const index = this.mapScrollAlarms().findIndex(a => a.id === alarm.id);
    if (index !== -1) {
      this.mapScrollAlarms.update(items => {
        const updated = [...items];
        updated[index] = { ...updated[index], ...alarm };
        return updated;
      });
    }
  }

  /** Eliminar una alarma del panel del mapa (UPDATE/resolve) */
  private removeFromMapScrollAlarms(alarmId: string): void {
    this.mapScrollAlarms.update(items => items.filter(a => a.id !== alarmId));
  }

  /** Eliminar múltiples alarmas del panel del mapa (BULK_RESOLVE) */
  private bulkRemoveFromMapScrollAlarms(alarmIds: string[]): void {
    const idsSet = new Set(alarmIds);
    this.mapScrollAlarms.update(items => items.filter(a => !idsSet.has(a.id)));
  }
}
